import type { JSX } from "react";

import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";

import type { TooltipTriggerProps } from "./Tooltip.types";

export function TooltipTrigger<Payload = unknown>({
  ...props
}: TooltipTriggerProps<Payload>): JSX.Element {
  return <BaseTooltip.Trigger data-slot="tooltip-trigger" {...props} />;
}
